// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.scrollable-content-indicator-module__wrapper___P43Kc {
  position: relative;
}

.scrollable-content-indicator-module__icon-position___sonpG {
  margin: 14px 9px;
  position: absolute;
  opacity: 0;
  background: var(--surface1, #fff);
  border-radius: 100%;
}
.scrollable-content-indicator-module__icon-position--bottomRight___lrCtk {
  bottom: 0;
  right: 0;
}
.scrollable-content-indicator-module__icon-position--bottomLeft___fof2d {
  bottom: 0;
  left: 0;
}
.scrollable-content-indicator-module__icon-position--bottomCenter___jn8gC {
  bottom: 0;
  left: calc(50% - 12px);
}
.scrollable-content-indicator-module__icon-position--topRight___CCMZV {
  top: 0;
  right: 0;
}
.scrollable-content-indicator-module__icon-position--topLeft___ypdUN {
  top: 0;
  left: 0;
}
.scrollable-content-indicator-module__icon-position--topCenter___eqdn2 {
  top: 0;
  left: calc(50% - 12px);
}

.scrollable-content-indicator-module__scrolling-animation___DHgil {
  animation: scrollable-content-indicator-module__scrolling-animation___DHgil 1s, scrollable-content-indicator-module__fade-out___eqfmR 4s;
  transform-origin: center bottom;
}

@keyframes scrollable-content-indicator-module__fade-out___eqfmR {
  0% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  99% {
    opacity: 0.01;
  }
  100% {
    opacity: 0;
  }
}
@keyframes scrollable-content-indicator-module__scrolling-animation___DHgil {
  from, 20%, 53%, 80%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateY(0);
  }
  40%, 43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translateY(3px);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translateY(-5px);
  }
  90% {
    transform: translateY(-4px);
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/general/scrollable-content-indicator/scrollable-content-indicator.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACIA;EACE,kBAAA;AAIF;;AADA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,mBAAA;AAIF;AAFE;EACE,SAAA;EACA,QAAA;AAIJ;AADE;EACE,SAAA;EACA,OAAA;AAGJ;AAAE;EACE,SAAA;EACA,sBAzBe;AA2BnB;AACE;EACE,MAAA;EACA,QAAA;AACJ;AAEE;EACE,MAAA;EACA,OAAA;AAAJ;AAGE;EACE,MAAA;EACA,sBAxCe;AAuCnB;;AAKA;EACE,wIAAA;EACA,+BAAA;AAFF;;AAKA;EACE;IACE,UAAA;EAFF;EAKA;IACE,UAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAOA;IACE,UAAA;EALF;AACF;AAQA;EACE;IAKE,8DAAA;IACA,wBAAA;EAVF;EAaA;IAEE,iEAAA;IACA,0BAAA;EAZF;EAeA;IACE,iEAAA;IACA,2BAAA;EAbF;EAgBA;IACE,2BAAA;EAdF;AACF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils';\n\n$centeredPosition: calc(50% - 12px);\n\n.wrapper {\n  position: relative;\n}\n\n.icon-position {\n  margin: 14px 9px;\n  position: absolute;\n  opacity: 0;\n  background: color(surface1);\n  border-radius: 100%;\n\n  &--bottomRight {\n    bottom: 0;\n    right: 0;\n  }\n\n  &--bottomLeft {\n    bottom: 0;\n    left: 0;\n  }\n\n  &--bottomCenter {\n    bottom: 0;\n    left: $centeredPosition;\n  }\n\n  &--topRight {\n    top: 0;\n    right: 0;\n  }\n\n  &--topLeft {\n    top: 0;\n    left: 0;\n  }\n\n  &--topCenter {\n    top: 0;\n    left: $centeredPosition;\n  }\n}\n\n.scrolling-animation {\n  animation: scrolling-animation 1s, fade-out 4s;\n  transform-origin: center bottom;\n}\n\n@keyframes fade-out {\n  0% {\n    opacity: 1;\n  }\n\n  95% {\n    opacity: 1;\n  }\n\n  99% {\n    opacity: 0.01;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes scrolling-animation {\n  from,\n  20%,\n  53%,\n  80%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateY(0);\n  }\n\n  40%,\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translateY(3px);\n  }\n\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translateY(-5px);\n  }\n\n  90% {\n    transform: translateY(-4px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `scrollable-content-indicator-module__wrapper___P43Kc`,
	"icon-position": `scrollable-content-indicator-module__icon-position___sonpG`,
	"icon-position--bottomRight": `scrollable-content-indicator-module__icon-position--bottomRight___lrCtk`,
	"icon-position--bottomLeft": `scrollable-content-indicator-module__icon-position--bottomLeft___fof2d`,
	"icon-position--bottomCenter": `scrollable-content-indicator-module__icon-position--bottomCenter___jn8gC`,
	"icon-position--topRight": `scrollable-content-indicator-module__icon-position--topRight___CCMZV`,
	"icon-position--topLeft": `scrollable-content-indicator-module__icon-position--topLeft___ypdUN`,
	"icon-position--topCenter": `scrollable-content-indicator-module__icon-position--topCenter___eqdn2`,
	"scrolling-animation": `scrollable-content-indicator-module__scrolling-animation___DHgil`,
	"fade-out": `scrollable-content-indicator-module__fade-out___eqfmR`
};
export default ___CSS_LOADER_EXPORT___;
